// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               const discountCode = document.getElementById("coupon-code").value??"";
//               console.log(discountCode);
//               if(!discountCode){
//                 this.handleErrorMessage(response.description);
//                 this.error = true;
//                 return;
//               }
//               window.location = `/checkout?discount=${discountCode}`;

//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }



// New Custom-Code


// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();
//         this.form = this.querySelector('form');

//         // Keep variant input enabled for Dawn-style forms
//         this.variantIdInput.disabled = false;

//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

//         // Drawer or notification component (Dawn)
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) {
//           this.submitButton.setAttribute('aria-haspopup', 'dialog');
//         }

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       // --- helpers ---------------------------------------------------------
//       getDiscountCode() {
//         // Priority: explicit input #coupon-code, else data attribute on form (data-discount)
//         const input = document.getElementById('coupon-code');
//         const fromInput = (input && input.value || '').trim();
//         if (fromInput) return fromInput;

//         const fromData = (this.form?.dataset?.discount || '').trim();
//         return fromData || ''; // empty if none
//       }

//       discountUrl(code, redirectPath = '/checkout') {
//         const c = encodeURIComponent(code.trim());
//         const r = encodeURIComponent(redirectPath);
//         return `/discount/${c}?redirect=${r}`;
//       }

//       wireDrawerCheckoutToDiscount(code) {
//         // Re-point any checkout buttons/links inside the drawer/notification
//         if (!this.cart || !code) return;

//         // Common selectors in Dawn-based drawers/notifications
//         const selectors = [
//           'a[href="/checkout"]',
//           'button[name="checkout"]',
//           'form[action="/checkout"]',
//           'a.checkout-button',
//           '.cart__checkout-button a',
//           '.cart__checkout-button button'
//         ];

//         const discountCheckoutUrl = this.discountUrl(code, '/checkout');

//         // Convert links
//         selectors.forEach(sel => {
//           this.cart.querySelectorAll(sel).forEach(el => {
//             if (el.tagName === 'A') {
//               el.setAttribute('href', discountCheckoutUrl);
//             } else if (el.tagName === 'FORM') {
//               el.addEventListener('submit', (e) => {
//                 e.preventDefault();
//                 window.location.href = discountCheckoutUrl;
//               }, { once: true });
//             } else {
//               // button
//               el.addEventListener('click', (e) => {
//                 e.preventDefault();
//                 window.location.href = discountCheckoutUrl;
//               });
//             }
//           });
//         });
//       }
//       // --------------------------------------------------------------------

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();
//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);

//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }

//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               // Error from /cart/add.js
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;

//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             }

//             const discountCode = this.getDiscountCode();

//             // If there's no cart UI (drawer/notification), go straight to checkout through /discount
//             if (!this.cart) {
//               if (!discountCode) {
//                 this.handleErrorMessage('Please enter a discount code.');
//                 this.error = true;
//                 return;
//               }
//               // Apply code and go to checkout (no double redirect)
//               window.location.href = this.discountUrl(discountCode, '/checkout');
//               return;
//             }else{ // forcing to go to the checkout page direclty if cart UI exit too, as per the requirement, if don't wat to got the checkout page in case of cart UI exist then remove this else block
//               if (!discountCode) {
//                 this.handleErrorMessage('Please enter a discount code.');
//                 this.error = true;
//                 return;
//               }
//               // Apply code and go to checkout (no double redirect)
//               window.location.href = this.discountUrl(discountCode, '/checkout');
//               return;
//             }

//             // With cart UI present: publish update & render, then wire the checkout button(s)
//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });

//             this.error = false;

//             const quickAddModal = this.closest('quick-add-modal');
//             const render = () => {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             };

//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     render();
//                     // After drawer is painted, wire the checkout button
//                     if (discountCode) this.wireDrawerCheckoutToDiscount(discountCode);
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               render();
//               // After drawer is painted, wire the checkout button
//               if (discountCode) this.wireDrawerCheckoutToDiscount(discountCode);
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');
//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;
//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;

//         this.errorMessage =
//           this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }



if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }


      // Helpers----------------------------------------

      buildLineItemProperties(formData) {
        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (!key.startsWith("properties[")) continue;

          const propKey = key.replace(/^properties\[|\]$/g, "");

          if (value === "" || value == null) continue;

          // Convert everything to string
          if (typeof value === "string") {
            properties[propKey] = value;
          } else {
            properties[propKey] = JSON.stringify(value);
          }
        }

        return properties;
      }






      onSubmitHandler(evt) {
        evt.preventDefault();


        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        for (let [key,value] of formData.entries()){
          console.log(key,":",value);
        }


        /**
         * normalizing the properties
         */
        const properties = this.buildLineItemProperties(formData);
        console.log(properties);
        /**
         * update the variantId and selling_plan_id based on the product type `eGift` or `normal`
         */
        let variantId = formData.get("id");
        let selling_plan_id =formData.get("selling_plan");

        /**
         * check the current giftProduct is eGift then use `id` and `selling_plan` of eGift product
         */
        if(!!formData.get("_eGiftProduct")){
          variantId = formData.get("_matchedVariantId");
          selling_plan_id = formData.get("_sellingPlanId");
        }


        const newFormData = {
          'items': [{
            'id': variantId,
            'selling_plan':selling_plan_id,
            'quantity': 1,
            'sections':`${formData.get("sections")}`,
            properties
          }]
        };
        console.log(newFormData);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(newFormData)
        }).then(async(response) => {
          if (!response.ok || response.status !== 200) {
            const errorObj = await response.json();
            throw new Error(errorObj.message || errorObj.description || 'Something went wrong while adding to the cart!');
            throw new Error('Unable to add to cart');
          }

          return await response.json()
        })
          .then((response) => {
            console.log(response);
            //  window.location.href = window.Shopify.routes.root + "checkout?discount=" + encodeURIComponent("nacwrxporavic");

            // Fetch updated cart state
            return fetch(window.Shopify.routes.root + "cart.js")
              .then(res => res.json())
              .then(cart => {
                // 🔔 Notify Shopify/Dawn that cart is updated
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: newFormData.items[0].id,
                  cartData: cart,
                });

                const couponCode = document.getElementById("coupon-code");

                // ✅ Now redirect to checkout with coupon
                window.location.href =
                  window.Shopify.routes.root +
                  "checkout?discount=" +
                  encodeURIComponent(couponCode.value);
              });
          })
          .catch((error) => {
            console.log('Add to cart failed:', error.message);
            // ✅ Show error instead of redirect
            this.handleErrorMessage(error.message);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}